var _style, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 816.3 945.6",
    style: {
      enableBackground: "new 0 0 816.3 945.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.6,709.4l1.1-6.2C279,706.9,278.6,709.2,278.6,709.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "175.2,513 175.2,513.5 176,513 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "123.5,564.6 123.5,564.6 123.5,564.6 151.9,526.1 179.5,526.3 151.9,526.1 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "402.2,623.9 450.1,762.7 430.5,704.5 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "339.6,173.4 339.7,173.4 277.9,132.6 277.9,132.7 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "222.6,327.2 222.6,327.2 186.1,308.7 275.8,244.5 275.9,244.5 275.9,244.5 186.1,308.7 190.4,239.6   190.4,239.6 186.1,308.7 175,329.9 175,329.9 134.8,348.2 222.6,327.2 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "176.7,513 176.5,513.1 244.1,526.7 244.1,526.7 244.1,526.7 244.1,526.7 244.1,526.7 176.7,513   176.7,513 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "135.8,457.8 167,500 135.8,457.8 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "54,488.3 59.2,446.3 54,488.3 123.4,462.4 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "239.7,528.1 244.1,526.7 244.1,526.7 "
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "63.2,498.5 100.2,509.8 151.4,526 151.4,526 151.4,526 174.3,513.9 110.9,511.3 110.9,510.3   110.9,510.3 110.9,510.3 110.9,510.3 110.9,510.3 110.9,510.3 102.2,506.9 54,488.3 28.9,466.6 45.8,501.4 50.1,494.4 "
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "154.7,406.7 154.6,406.5 167.6,370.9 135.8,457.8 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "244.1,526.7 244.1,526.7 244.1,526.7 243.7,527.3 244.1,526.7 244.1,526.7 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "185.8,474.9 135.8,457.8 185.9,475.1 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "244.1,526.7 216.9,715.8 226.2,651.5 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "350.5,410.5 350.5,410.3 347.4,311 "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "531.9,319.2 584.2,303.5 479.1,334.9 "
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "374,129.6 333.6,103.6 431.7,167 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "15.3,386.7 9.6,399 55.6,399.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42,367.7 18.7,383.6 63.7,397.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.5,351.6 46,366.4 69.3,398.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.4,310 50.4,361.5 132.1,346.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.7,274 121.9,301.6 179.5,247.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.8,238.2 197.3,215.8 138.4,262.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.3,249.1 121.7,307.3 135.1,343.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66,403.6 20.4,403.1 61.4,415.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.9,433.9 29.9,461.4 57.3,422.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.9,485.5 38.8,491.5 32.1,477.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.1,505.8 50.4,551.2 116.3,561.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.7,425.8 31.6,466.2 52.5,484.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.4,501 103.8,546.4 62.1,500.2 51,496.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.4,504.5 130.6,461.9 59.6,488.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.7,482.6 158.9,377 64.5,419.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.2,414.2 136.5,382.7 70.4,403.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.3,396.6 163.1,370.2 134.9,350.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.2,456.3 162.5,379 61.6,483.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.7,511.5 69.5,502.5 116.9,554.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.7,513 176.7,513 176.5,513.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.8,461.3 105.3,506 111.3,508.3 172.6,510.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.2,461.8 175.8,508.4 183.5,476.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.4,456.6 182.5,471.7 154.9,411.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.1,199.1 129.1,265.1 197.6,210.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.5,141.2 168.1,196.2 201.2,207.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208,206.2 303.6,183.7 277.4,135.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275,241.9 302.8,188 207.8,210.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.9,184.6 361,194.8 339.2,175.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.1,280.9 366.1,200 310.8,188  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.1,199.2c13.6,43.3,30.8,97.4,35,108.7c4-3.6,13.9-13.1,20.7-19.9L313.1,199.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.1,304.3 306.2,190.2 278.3,244.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.2,237.8 265.6,241.9 202.8,212.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.6,527.2 103.7,513 123.7,560.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.4,566.4 113.1,711.7 239.1,530.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.9,528.1 128.5,561.2 231.4,528.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.3,515.1 159.1,524.2 223.3,524.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.2,412.9 180.6,511.8 242.7,524.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.7,476.2 180.4,506.1 259.6,421.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.7,408.5 186.7,472 271.3,407.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.6,403.7 168.8,373.4 157.5,404.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.2,328.6 186.2,252.1 139.2,344  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.1,317.7 184.1,308.1 186,277  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.3,304.6 270.1,246.2 192.3,241.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.9,308.4 221.9,324.6 268.5,252.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.5,368.4 214.3,331.3 139.6,349.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.2,401.3 229.8,359.9 175.5,371.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234,358.4 277,402.6 341.5,315.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228,356.2 221.4,330.7 175.5,367.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.1,354.1 343.7,310.3 276.6,248  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.8,327.6 230.9,351.3 266.2,263.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.5,182.7 335.2,172.9 283.5,138.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.8,132.8 337.3,169.4 331.9,106.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.6,172.4 363.5,191.7 336.9,118.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.8,607.9 216.3,706.2 241,534.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.9,565.2 245.7,530 229.1,645.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.3,560.8 276.9,414.6 246.5,525.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.7,407.9 307.5,556.1 348,414.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.5,316.8 280.9,404 348.5,410.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.9,359.7 351.3,317 390.9,442.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.4,444.5 349.8,325.5 352.5,409.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.1,412 311.9,555 389.1,451.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310,564.2 400,620.2 390.1,457.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.8,291.7 350.4,310.9 398.4,351.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.3,286.1 471.2,279.2 370.2,202.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.7,283.1 374.4,290.1 404.6,355.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.9,359.8 395.3,440.1 468.7,292.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.7,169.8 371.9,198.8 472.1,274.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.2,195.6 427.7,166.8 337.5,108.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.9,332.3 576.1,303.9 478.7,283.3  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,334.3l-2.1-45.8c-25.9,51.2-60,119.1-74.4,148.8C417.5,415,452,368.3,477,334.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "588.2,352.7 486,337.9 614.3,441.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "488.3,334.2 579.1,347.3 531.6,321.3  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.4,460.6c-1-14.1-1.9-27.6-2.7-38.7l-96.6-78.7L585.4,460.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "467,463 588,542.9 480.3,341.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.3,342 395.3,450.3 463.2,461.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.3,454.5c31.5,42.7,74.9,101.1,89.2,119.6c-4.2-21.2-16.6-81.4-22.3-108.4L396.3,454.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.8,473.2 490.6,580 562.8,609.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473,655.7 486.8,582 398.8,464.5 472.8,656.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.9,575 396.4,468.7 429.9,687.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.9,643.6 396.3,493.4 404.2,623.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.3,668.4 398.9,624.2 311.2,569.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.9,651.6c16.8,19.2,40.7,46.1,48.3,53.9c3.3-17.9,18.4-93.5,26.5-134.2L228.9,651.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.6,731.8c-4.6-28.4-18.4-120-23.6-154l-0.3-1.5l-16.8,81.8C302.7,681.9,321.8,717.1,330.6,731.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.2,573 309,577.5 328.7,695.5 348.2,671.5 308.3,573.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399,629.6 353.4,672 384.1,703.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.7,476.1 547.8,580.8 608.2,592.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "488.3,481.9 585.5,567.2 577.5,540.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.2,796.9 214.7,715.5 187.3,617.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.6,615.4 138.8,680.4 169.8,726.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238,823 275.7,711.7 219.3,717.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.6,656 219.3,713.6 274.5,707.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.7,713.4 288.8,664.3 280.6,709.4 301,822.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319,718.9 300.9,856.7 338.9,777.4 332,740.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.3,680.2 329.6,700.8 333.9,728.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.3,801.2 381.4,712.6 335.6,739.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.6,675.8 336.5,734.2 382.1,707.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.2,651.8 408.2,634.9 425.8,685.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.3,799.5 447.8,762 404.1,635.5  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.9,820.3c3.8-3.5,10.8-10.5,17.2-17.2l-11.8-76.2C384.3,761.4,381.7,806.6,380.9,820.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.5,779.6 400,645.2 387.4,708  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "470,670 432.8,705.1 449.8,755.4 469.4,672.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.2,584 432.9,699.5 471.2,663.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.4,526 151.9,526.1 151.9,526.1 151.9,526.1 151.9,526.1 151.4,526 151.4,526  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.6,89 184.5,182.9 276.4,131.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.7,127 392.5,105.7 340.5,105.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.3,186.7 530.2,174.3 443.7,169.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "489.9,274.1 592,239.4 554.8,230.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "606.3,306 555.7,276.7 490.5,281.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "492.1,277.6 555,272.7 565.6,252.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "585.1,289.1 600.7,286.6 568.4,279.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "559.7,272.3 598.6,268.7 570.5,251.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582.5,306.1 537,319.7 587.3,347.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "591.5,348.4 637.8,337.2 586.7,307.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "596.7,367.4 635,362.6 592.6,353.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "642.5,416 599.3,376 607.1,402.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "586.9,425.3 589.2,461.4 655,479.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.2,513.8 627.3,475.6 592.8,466.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "511.5,669 489.2,589.8 475,656.1 473.4,663.5 473.4,663.5 473.3,664.1 471.3,673.2 454.2,753.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "515.6,668.8 515.6,668.9 515.6,669 528.9,738.4 540.9,659.9 494.1,592.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497.9,590.9 544.4,657.9 559.7,667.6 541.9,624.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "501.7,588.8 544.7,621.8 589.1,650.1 566.9,615.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "551.1,585.6 569.7,612.1 601.7,637.9 582.5,592  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.1,127.6l49-25.5c6.3-12.6,14.9-29.6,19.4-38.9c-11.4,8.4-36.4,27-54.5,40.5L283.1,127.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.7,164.6 476.5,134.3 381.1,131.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.8,826.4 447.1,767.7 403.5,803.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "586.7,465.4 585.8,464.2 585.6,464 489.7,350.6 590.9,539.8 592,542 593.1,544.1 594.8,547.3 678,578 587.8,466.7     "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.8,808.3 375,853 382.6,720.6  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.3,677.9l-57.9,85c11.2,24.1,27,57.8,33.3,70.4C489.5,808.1,504.6,713.5,510.3,677.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.5,766.6 527.1,749.9 516.7,695.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "515.8,774.4 512.5,690 495.2,800.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.3,170.6 475.3,272.5 484.1,190.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "488,190.9 479,275.5 562.7,195.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "562.4,200.9 494.7,266 552.8,226.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "578.5,767.3 587.3,738.1 563.9,732.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "630.5,709.4 677.4,724.6 633.5,682.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644,629.9 658.5,640.5 661.1,623.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471,62.2 458,81.1 488.4,85.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "657.9,85.2 655.5,108 684.3,97.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "762.9,440.6 753.9,453.5 796.8,468.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "604.8,857.9 620.3,855.7 601.9,814.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "720.2,616.4 763.5,629.9 728.8,603.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "574.9,71.7 530,112.2 549.5,122.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "658.2,231.3 627.9,258.9 671.5,262.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "618.4,153.7 602.5,155 605.2,174.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.7,322.8 713.9,301.6 674.7,324.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "689.9,501.2 700.5,537.6 733.8,536.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "712,375.8 681,374.3 715,400.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.3,847.4 201.7,825.9 193.5,807.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.5,916 262.8,882.7 237.1,875.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.2,849.9 424.3,873.6 419.6,849.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497.5,886.3 519,876.3 473.1,862  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.2,16 403.2,39.8 412.7,61.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.8,930.8 361,905.6 344.2,880.4  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLion);
export default __webpack_public_path__ + "static/media/lion.5a6ac74dc41789c145659a621c6e5ab1.svg";
export { ForwardRef as ReactComponent };